/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const setSocialLibraryMinClipsDataSchema = z.object({
  minClips: z.number(),
});

export interface ISetSocialLibraryMinClipsV1Data {
  minClips: number;
}

export const setSocialLibraryMinClipsV1ResponseSchema = createApiResponseSchema(
  setSocialLibraryMinClipsDataSchema,
) as z.ZodSchema<IAPI<ISetSocialLibraryMinClipsV1Data>>;

export type ISetSocialLibraryMinClipsV1Response = IAPI<ISetSocialLibraryMinClipsV1Data>;
